<app-app-nav></app-app-nav>
<!-- END header -->
<main id="mainContent" tabindex="-1">
  <!-- whatsapp floating button -->
  <app-whatsapp></app-whatsapp>
  <!-- END whatsapp floating button -->

  <section class="news-page py-5">
    <div class="container-fluid news-inner">

      <!-- Page title -->
      <div class="news-head d-flex justify-content-between align-items-center flex-wrap">
        <div class="news-head-title d-flex align-items-center animate__animated animate__fadeInUp wow">
          <span class="news-head-accent"></span>
          <h1 class="heading-font fw-bold mb-0">أخبار أكاديمية الفنون</h1>
        </div>
      </div>

      <!-- Featured -->
      <div class="featured-grid" *ngIf="sliderNews?.length && !keyword">
        <a class="featured-card featured-main animate__animated animate__fadeInUp wow"
          *ngIf="sliderNews[0]" (click)="newsDetails(sliderNews[0])" role="button" tabindex="0" (keydown.enter)="newsDetails(sliderNews[0])" (keydown.space)="newsDetails(sliderNews[0])">
          <img class="featured-img" src="{{sliderNews[0].IMG_PATH}}" [alt]="sliderNews[0].TITLE" alt="">
          <div class="featured-overlay"></div>
          <div class="featured-caption">
            <span class="featured-date">{{sliderNews[0].NEW_DATE | date:'yyyy/MM/dd'}}</span>
            <h2 class="featured-title heading-font">{{sliderNews[0].TITLE}}</h2>
          </div>
        </a>

        <div class="featured-side">
          <a class="featured-card animate__animated animate__fadeInDown wow"
            *ngFor="let item of sliderNews | slice:1:3" (click)="newsDetails(item)" role="button" tabindex="0" (keydown.enter)="newsDetails(item)" (keydown.space)="newsDetails(item)">
            <img class="featured-img" src="{{item.IMG_PATH}}" [alt]="item.TITLE" alt="">
            <div class="featured-overlay"></div>
            <div class="featured-caption">
              <span class="featured-date">{{item.NEW_DATE | date:'yyyy/MM/dd'}}</span>
              <h3 class="featured-title sm heading-font">{{item.TITLE}}</h3>
            </div>
          </a>
        </div>
      </div>

      <!-- Top news -->
      <section class="mt-5 pt-2" *ngIf="topNews?.length && !keyword">
        <div class="news-head">
          <div class="news-head-title d-flex align-items-center">
            <span class="news-head-accent"></span>
            <h2 class="heading-font fw-bold mb-0">أهم الأخبار</h2>
          </div>
        </div>
        <div class="news-grid">
          <a class="news-card animate__animated animate__fadeInUp wow" *ngFor="let item of topNews"
            (click)="newsDetails(item)" role="button" tabindex="0" (keydown.enter)="newsDetails(item)" (keydown.space)="newsDetails(item)">
            <div class="news-card-media overflow-hidden">
              <img class="news-card-img" src="{{item.IMG_PATH}}" [alt]="item.TITLE" alt="">
              <span class="news-card-date">{{item.NEW_DATE | date:'yyyy/MM/dd'}}</span>
            </div>
            <div class="news-card-body">
              <span class="news-card-cat" *ngIf="item.FACULTY_NAME">{{item.FACULTY_NAME}}</span>
              <h3 class="news-card-title heading-font">{{item.TITLE}}</h3>
              <span class="news-card-more">اقرأ المزيد <i class="icon-arrow-sm"></i></span>
            </div>
          </a>
        </div>
      </section>

      <!-- Latest news -->
      <section class="mt-5 pt-2">
        <div class="news-head d-flex justify-content-between align-items-center flex-wrap">
          <div class="news-head-title d-flex align-items-center">
            <span class="news-head-accent"></span>
            <h2 class="heading-font fw-bold mb-0">أحدث الأخبار</h2>
          </div>
        </div>

        <!-- News filter bar: keyword search + institute dropdown -->
        <div class="news-filter-bar d-flex flex-wrap align-items-center gap-2 mb-4">
          <div class="news-filter-search position-relative flex-grow-1">
            <i class="icon-search news-filter-search-icon"></i>
            <input type="text" class="form-control" [(ngModel)]="keyword" (ngModelChange)="applyKeyword()"
              placeholder="ابحث في الأخبار بكلمة..." aria-label="ابحث في الأخبار">
          </div>
          <select class="form-select news-filter-select" [(ngModel)]="selectedFacultyId" (ngModelChange)="onFacultyChange()"
            aria-label="تصفية حسب المعهد">
            <option value="">كل المعاهد</option>
            <option *ngFor="let f of faculties" [value]="f.ID">{{f.FACULTY_NAME}}</option>
          </select>
          <button type="button" class="btn btn-outline-secondary news-filter-clear"
            *ngIf="keyword || selectedFacultyId" (click)="clearFilters()">
            مسح الفلتر
          </button>
        </div>

        <!-- No results -->
        <div class="text-center py-5 text-secondary" *ngIf="LatestNews && LatestNews.length === 0">
          لا توجد أخبار مطابقة لبحثك.
        </div>

        <div class="latest-list">
          <a class="latest-card animate__animated animate__fadeIn wow" *ngFor="let item of LatestNews"
            (click)="newsDetails(item)" role="button" tabindex="0" (keydown.enter)="newsDetails(item)" (keydown.space)="newsDetails(item)">
            <div class="latest-media overflow-hidden">
              <img class="latest-img" src="{{item.IMG_PATH}}" [alt]="item.TITLE" alt="">
            </div>
            <div class="latest-body">
              <div class="latest-meta">
                <span class="latest-date">{{item.NEW_DATE | date:'yyyy/MM/dd'}}</span>
                <span class="latest-faculty" *ngIf="item.FACULTY_NAME">{{item.FACULTY_NAME}}</span>
              </div>
              <h3 class="latest-title heading-font">{{item.TITLE}}</h3>
              <p class="latest-brief" *ngIf="item.DETAILS">{{item.DETAILS}}</p>
              <span class="news-card-more">اقرأ المزيد <i class="icon-arrow-sm"></i></span>
            </div>
          </a>
        </div>

        <div class="text-center pt-4" *ngIf="!keyword && LatestNews?.length">
          <a (click)="moreNews()" class="more-news-btn d-inline-flex align-items-center fw-medium" role="button" tabindex="0" (keydown.enter)="moreNews()" (keydown.space)="moreNews()">
            المزيد من الأخبار
            <i class="icon-arrow-sm"></i>
          </a>
        </div>
      </section>

    </div>
  </section>
</main>
